import { h, FunctionalComponent } from "preact";
import style from "./documentStyle.module.css";

export interface DocumentItem {
  details: string;
  url: string;
  type: string;
  pageNumber?: number;
}

interface Props {
  documents: DocumentItem[];
  setDrawerOpen?: (value: boolean) => void;
  setDocDetail?: any;

  totalPages: number;
  currentPage: number;
  onPageChange: (page: number) => void;
}

const DocumentsTable: FunctionalComponent<Props> = ({
  documents,
  setDocDetail,
  setDrawerOpen,
  totalPages,
  currentPage,
  onPageChange,
}) => {
  const getIconForType = (type: string): string => {
    const docIconSrc = "/assets/icons/doc_s_icon.svg";
    const videoIconSrc = "/assets/icons/video_s_icon.svg";
    const presentationIconSrc = "/assets/icons/presentation_s_icon.svg";
    const tableIconSrc = "/assets/icons/table_icon.svg";

    const ext = type.toLowerCase();

    if (["ppt", "pptx"].includes(ext)) return presentationIconSrc;
    if (["doc", "docx", "pdf", "txt"].includes(ext)) return docIconSrc;
    if (["xls", "xlsx", "csv"].includes(ext)) return tableIconSrc;
    if (["mp4", "mov", "avi", "webm"].includes(ext)) return videoIconSrc;

    return docIconSrc;
  };

  return (
    <div class={style.tableWrapper}>
      <table class={style.table}>
        <thead>
          <tr>
            <th>Icon</th>
            <th>Name</th>
            <th>Type</th>
          </tr>
        </thead>

        <tbody>
          {documents.map((doc, index) => (
            <tr
              key={index}
              class={style.row}
              onClick={() => {
                if (!setDrawerOpen) return;

                const kappMatch = doc?.url?.match(/\/kapp\/([a-zA-Z0-9]+)/);
                const docGuidMatch = doc?.url?.match(
                  /\/docGuid\/([a-zA-Z0-9-]+)/
                );
                const guidMatch = doc?.url?.match(/\/guid\/([a-zA-Z0-9-]+)/);

                setDocDetail({
                  type: doc.type,
                  kapp: kappMatch ? kappMatch[1] : null,
                  docGuid: docGuidMatch ? docGuidMatch[1] : null,
                  guid: guidMatch ? guidMatch[1] : null,
                  page: doc?.pageNumber ?? 0,
                });

                setDrawerOpen(true);
              }}
            >
              <td>
                <img
                  src={getIconForType(doc.type)}
                  class={style.icon}
                  alt={doc.type}
                />
              </td>

              <td class={style.nameCell} title={doc.details}>
                {doc.details}
              </td>
              <td>{doc.type.toUpperCase()}</td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Pagination Section */}
      <div class={style.paginationWrapper}>
        {/* Prev Button */}
        {currentPage > 1 && (
          <button onClick={() => onPageChange(currentPage - 1)}>Prev</button>
        )}

        {/* Page Input */}
        <div class={style.pageJumpWrapper}>
          <span>Page</span>

          <input
            class={style.pageInput}
            type="number"
            min="1"
            max={totalPages}
            value={currentPage}
            onInput={(e: any) => {
              const value = parseInt(e.target.value, 10);
              if (!isNaN(value)) onPageChange(value);
            }}
            onBlur={(e: any) => {
              let value = parseInt(e.target.value, 10);
              if (isNaN(value) || value < 1) value = 1;
              if (value > totalPages) value = totalPages;
              onPageChange(value);
            }}
          />

          <span>of {totalPages}</span>
        </div>

        {/* Next Button */}
        {currentPage < totalPages && (
          <button onClick={() => onPageChange(currentPage + 1)}>Next</button>
        )}
      </div>
    </div>
  );
};

export default DocumentsTable;
